import { TrackableAction } from '@apps/clos-sessions/state/processing';
import { ClosArchivePriceDetails } from '@apps/clos-sessions/state/archives/types';

export class RemoveArchives implements TrackableAction {
  static readonly type = '[Archives] Remove Archives';

  readonly track = true;

  constructor(readonly payload: { archiveIds: string[] }) {}
}

export class CreateArchive implements TrackableAction {
  static readonly type = '[Archives] Create Archives';

  readonly track = true;

  constructor(readonly payload: { name?: string; guid: string }) {}
}

export class FetchArchives implements TrackableAction {
  static readonly type = '[Archives] Fetch Archives';

  readonly track = true;
}

export class FetchArchivesNextPaginationChunk implements TrackableAction {
  static readonly type = '[Archives] Fetch Next Pagination Chunk';

  readonly track = true;
}

export class SyncArchive implements TrackableAction {
  static readonly type = '[Archives] Sync Archive';

  readonly track = true;

  constructor(readonly payload: { archive: { id: string } }) {}
}

export class FetchInspection implements TrackableAction {
  static readonly type = '[Archives] Fetch Inspection';

  readonly track = true;

  constructor(readonly payload: { archive: { id: string } }) {}
}

export class SetArchivePrice implements TrackableAction {
  static readonly type = '[Archives] Set Archive Price';

  readonly track = true;

  constructor(
    readonly payload: {
      archive: { id: string };
      price: Partial<ClosArchivePriceDetails>;
    },
  ) {}
}
